import { render, staticRenderFns } from "./MailSnippet.vue?vue&type=template&id=32d61dd8&"
import script from "./MailSnippet.vue?vue&type=script&lang=js&"
export * from "./MailSnippet.vue?vue&type=script&lang=js&"
import style0 from "./MailSnippet.vue?vue&type=style&index=0&id=32d61dd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports